import {
  Button,
  Checkbox,
  Col,
  Form,
  Modal,
  notification,
  Row,
  Tooltip,
  Input,
  Divider,
  Spin,
} from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { Label } from '../../../compnents/widgets/Label'
import styles from './personalSetting.module.css'
import {
  Checks,
  Settinglable,
} from '../../../models/personalSetting'
import { useQuery } from '../../../utils/HttpUtils'
import {
  getAllPersonalPreferences,
  getUserProfileList,
  saveSetting,
} from '../personalDetail/personalDetailSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import _ from 'lodash'
import {
  selectEdition,
  selectTenantId,
  selectTenantName,
  selectUserId,
} from '../../../app/applicationSlice'
import {
  CloseCircleOutlined,
  CloseOutlined,
  QuestionCircleTwoTone,
} from '@ant-design/icons'
import {
  EditableRecipeCategories,
  EditableRecipeCategoriesWithTcmApply,
  getRecipeCategoryName,
  getSortRecipeCategoryName,
  RecipeCategory,
  ToothEditableRecipeCategories,
} from '../../../models/recipe'
import { ThemeContext } from '../../../theme/ThemeContext'
import { RecipeItemInput } from '../../treatment/editor/components/RecipeItemInput'
import { selectSettings } from '../../user/setting/settingSlice'

export const SquareRootSetting = (props: {
  selectedTab: any
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const query = useQuery()

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const settings = useSelector(selectSettings)

  const userId = useSelector(selectUserId)

  const tenantId = useSelector(selectTenantId)

  const tenantName = useSelector(selectTenantName)

  const id = query.get('id') as string

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const [EWFYFlag, setEWFYFlag] = useState<any>(0)

  const [checkData, setCheckData] = useState<any>([])

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [formData, setFormData] = useState<any>([])

  const [ewfyInput, setEwfyInput] = useState('')

  const [loading, setLoading] = useState(false)

  const [submitLoading, setSubmitLoading] = useState(false)

  const [selectedDiseases, setSelectedDiseases] = useState<any[]>([])

  // 176中药贴敷方
  const RecipeCategories = hisVersion == 1 ? ToothEditableRecipeCategories
    : (settings?.[176]) ? EditableRecipeCategoriesWithTcmApply : EditableRecipeCategories

  useEffect(() => {
    setTimeout(function () {
      setIsModalVisible(false)
    }, 3000)
  }, [dispatch, isModalVisible])

  const getShowData = () => {
    setLoading(true)
    dispatch(getUserProfileList({ userId: id }))
      .then(unwrapResult)
      .then((c: any) => {
        setCheckData(c)
        const ewfyFlag = c?.filter((v: any) => v?.code == '9') //是否开启方自动生成其他费用
        if (ewfyFlag?.length) {
          setEWFYFlag(Number(ewfyFlag?.[0]?.switchFlag))
          setSelectedDiseases(ewfyFlag?.[0]?.codeMap)
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if (props?.selectedTab == '3') {
      getShowData()
    }
  }, [dispatch, props?.selectedTab])

  useEffect(() => {
    const XzyktdcfList = checkData?.filter((v: any) => v?.code == '15') //选择要开通的处方

    const XzyktdcfValue = XzyktdcfList?.[0]?.codeName //选择要开通的处方

    const XzyktdcfValueList = settings?.[176] ? XzyktdcfValue?.split(',').map(Number)  : XzyktdcfValue?.split(',').map(Number) ?.filter((v: any) => v != 15)

    const list = XzyktdcfList?.length ? (XzyktdcfValue ? XzyktdcfValueList : []) : RecipeCategories

    const MrcfszList = checkData?.filter((v: any) => v?.code == '2') //开方时默认自动创建处方

    const MrcfszValue = MrcfszList?.[0]?.codeName //开方时默认自动创建处方

    // 口腔默认勾选处置项目
    const KQMrcfszValue = MrcfszList?.length ? (MrcfszValue ? MrcfszValue?.split(',').map(Number) : []) : [13]

    // 通用默认勾选西药方、中药方、治疗
    const ElseMrcfszValue = MrcfszList?.length ? (MrcfszValue ? MrcfszValue?.split(',').map(Number) : []) : [1, 3, 4]

    const MRtsValue = checkData?.filter((v: any) => v?.code == '8')?.[0]
      ?.codeName //中药默认帖数

    const HbfzValue = checkData?.filter((v: any) => v?.code == '11')?.[0]
      ?.codeName //同步同组药品的频次/用法/天数

    form.setFieldsValue({
      [Checks.Hbfz]: HbfzValue == 'true' ? true : false, //同步同组药品的频次/用法/天数
      [Checks.MRts]: MRtsValue && MRtsValue != 'false' ? MRtsValue : 7, //中药默认帖数
      [Checks.Mrcfsz]: hisVersion == 1 ? KQMrcfszValue : ElseMrcfszValue, //开方时默认自动创建处方
      [Checks.XZYKTDCF]: list,  //选择要开通的处方
    })
    const dataList = list?.slice()
    .sort((a: any, b: any) => getSortRecipeCategoryName(getRecipeCategoryName(a)) - getSortRecipeCategoryName(getRecipeCategoryName(b)))
    setFormData(dataList)

  }, [dispatch, checkData])

  const getAllCheckData = () => {
    dispatch(getAllPersonalPreferences({ userId: id ? id : userId }))
      .then(unwrapResult)
      .then((c: any) => {
        const allPersonalPreferences = JSON.stringify(c)
        localStorage.setItem('allPersonalPreferences', allPersonalPreferences)
      })
  }

  return (
    <>
      <div className={styles.squareRootSetting}>
        <Form
          style={{ height: '100%' }}
          form={form}
          onFinish={(values) => {
            if (!values?.[Checks.XZYKTDCF]?.length) {
              notification.error({ message: '请选择要开通的处方' })
              return
            }
            if (!values?.[Checks.Mrcfsz]?.length) {
              notification.error({ message: '请选择默认处方设置' })
              return
            }
            const ewfy =
              (EWFYFlag == 1 ? '1#' : '0#') +
              selectedDiseases?.map((v) => v.id).join(',')
            const pattern = /^[1-9]*$/
            const f =
              values &&
              _.chain(values)
                .pickBy((_, k) => pattern.test(k))
                .mapValues(
                  (v, k) =>
                  ({
                    code: k,
                    codeName:
                      // Checks.Hbfz 同步同组药品的频次/用法/天数
                      // Checks.MRts 中药默认帖数
                      // Checks.Ewfy 是否开启方自动生成其他费用
                      k === Checks.Hbfz.toString() ? (v ? true : false)
                        : k === Checks.MRts.toString() ? v?.toString()
                          : k === Checks.Ewfy.toString() ? ewfy
                            : typeof v === 'number' || typeof v === 'string' ? v?.toString() : (v?.length ? v?.join(',') : ''),
                    userId: id ? id : userId,
                  } as Settinglable)
                )
                .values()
                .value()
            const uniqueF = _.uniqBy(f, 'code')
            setSubmitLoading(true)
            dispatch(saveSetting(uniqueF))
              .then(unwrapResult)
              .then(() => {
                notification.success({
                  message: '保存成功',
                  duration: 3,
                })
                getShowData()
                getAllCheckData()
                localStorage.setItem(
                  'tipsCount',
                  form.getFieldValue([Checks.MRts])
                    ? form.getFieldValue([Checks.MRts])
                    : 7
                )
              })
              .finally(() => {
                setEwfyInput('')
                setSelectedDiseases([])
                form.setFieldsValue({ [Checks.Ewfy]: [0] })
                setSubmitLoading(false)
              })
          }}
        >
          <div className={styles.formContent}>
            <Spin spinning={loading} style={{ paddingTop: '200px' }}>

              <Label label='处方类型设置' style={{ fontSize: 17 }} noIcon={true}/>
              <Divider dashed style={{ margin: 0, marginBottom: 10 }} />
              <Row className={styles.checkboxRow}>
                <Form.Item
                  label='选择要开通的处方'
                  name={Checks.XZYKTDCF}
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <Checkbox.Group
                    onChange={(e) => {
                      console.log(e,"e")
                      const dataList = e?.slice()
                      .sort((a: any, b: any) => getSortRecipeCategoryName(getRecipeCategoryName(a)) - getSortRecipeCategoryName(getRecipeCategoryName(b)))
                      setFormData(dataList)
                      const currentMrcfsz: any[] = form.getFieldValue(Checks.Mrcfsz) || []
                      form.setFieldsValue({
                        [Checks.Mrcfsz]: currentMrcfsz.filter((v: any) => e.includes(v))
                      })
                    }} style={{ width: '100%' }}>
                    {RecipeCategories.map((c) => {
                      return (
                        <Checkbox key={c} value={c} style={{ width: '16%' }}>
                          {getRecipeCategoryName(c)}
                        </Checkbox>
                      )
                    })}
                  </Checkbox.Group>
                </Form.Item>
              </Row>
              <Row className={styles.checkboxRow}>
                <Form.Item
                  label='开方时默认自动创建处方'
                  name={Checks.Mrcfsz}
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <Checkbox.Group style={{ width: '100%' }}>
                    {formData.map((c: any) => {
                      return (
                        <Checkbox key={c} value={c} style={{ width: '16%' }}>
                          {getRecipeCategoryName(c)}
                        </Checkbox>
                      )
                    })}
                  </Checkbox.Group>
                </Form.Item>
              </Row>
              <Label label='开方设置' style={{ fontSize: 17 }} noIcon={true}/>
              <Divider dashed style={{ margin: 0, marginBottom: 10 }} />
              {/* <Row style={{ marginBottom: 0 }} className={styles.checkboxRow}>
              <Form.Item
                label='开方选择库存设置'
                name={''}
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                <Radio.Group style={{ width: '90%' }}>
                  <Radio key={0} value={0} style={{ width: '22%' }}>
                    忽略库存开方
                  </Radio>
                  <Radio key={1} value={1} style={{ width: '22%' }}>
                    指定批次开方
                  </Radio>
                  <Radio key={2} value={2} style={{ width: '22%' }}>
                    不指定批次开方
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Row> */}
              <Row >
                <Form.Item
                  label='同步同组药品的频次/用法/天数'
                  name={Checks.Hbfz}
                  valuePropName='checked'
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <Checkbox><span>开启</span><span style={{ marginLeft: '8px', fontSize: '12px', color: '#999' }}>(开启后,同组药品的频次/用法/天数会保持一致,如不一致会自动调整,会以同组药品的第一个药为准)</span></Checkbox>
                </Form.Item>
              </Row>
              {(hisVersion == 0 && (formData?.includes(RecipeCategory.Tcm) || formData?.includes(RecipeCategory.TcmGranules))) ? (
                <>
                  <Row className={styles.tipsRow}>
                    <Form.Item
                      label='中药默认帖数'
                      name={Checks.MRts}
                      style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                      }}
                      rules={[
                        {
                          pattern: /[1-9]\d*$/,
                          message: '请输入大于0的整数',
                        },
                      ]}
                    >
                      <Input style={{ width: '120px' }} addonAfter='帖' />
                    </Form.Item>
                  </Row>
                </>
              ) : (
                <></>
              )}
              <Row>
                <Col style={{ width: '370px' }}>
                  <Form.Item
                    label='开方自动生成额外费用'
                    name={Checks.Ewfy}
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <Checkbox
                      checked={EWFYFlag == 1 ? true : false}
                      onClick={(v: any) => {
                        setEWFYFlag(v?.target?.checked ? 1 : 0)
                      }}
                    >
                      开启
                      <Tooltip
                        placement='right'
                        title='开启后，在医生开方时会自动生成一个其他费用单，其他费用单里会自动添加设置好的诊疗费用'
                        trigger={['click']}
                      >
                        <QuestionCircleTwoTone style={{ marginLeft: '10px' }} />
                      </Tooltip>
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col span={10} >
                  <Form.Item noStyle>
                    <RecipeItemInput
                      isRestrictUser={1} //是否限制用户
                      style={{
                        width: '100%',
                        height: '2rem',
                        color: theme.tc1,
                      }}
                      placeholder='请输入诊疗项目'
                      autoFocus
                      type={2}
                      value={ewfyInput}
                      onSelect={(m, ignoreStorage) => {
                        setEwfyInput('')
                        setSelectedDiseases(selectedDiseases.concat([{
                          id: m.id,
                          name: m.name,
                          price: m.retailPrice
                        }]))
                      }}
                      onChange={(v) => {
                        setEwfyInput(v)
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ marginLeft: '260px' }}>
                <Col
                  style={{
                    padding: '10px 10px 0 0px',
                    marginBottom: 10,
                  }}
                >
                  {selectedDiseases?.map((d, index) => (
                    <div key={index} className={styles.disease}>
                      {`${d.name}${d.price}`}{'元 '}
                      <CloseOutlined
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          const list = [...selectedDiseases]
                          list.splice(index, 1)
                          setSelectedDiseases(list)
                        }}
                      />
                    </div>
                  ))}
                </Col>
              </Row>
            </Spin>
          </div>
          <Row style={{ paddingTop: '10px', justifyContent: 'center' }}>
            <Button

              onClick={() => {
                getShowData()
              }}
              style={{
                marginRight: '10px',
              }}
            >
              取消
            </Button>
            <Button
              loading={submitLoading}
              type='primary'

              onClick={() => {
                form.submit()
              }}
            >
              保存
            </Button>
          </Row>
        </Form>
        <Modal
          width={350}
          title={null}
          visible={isModalVisible}
          footer={null}
          centered
          closable={false}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CloseCircleOutlined
              style={{ fill: 'red', fontSize: '18px', marginRight: '20px' }}
            />
            <p className={styles.message}>请至少勾选保存一份诊断病历</p>
          </div>
        </Modal>
      </div>
    </>
  )
}
